export default __webpack_public_path__ + "static/media/shradha.aa158024.jpg";